<app-admin-page-shell
  titleKey="app.admin.dailyFacts.title"
  subtitleKey="app.admin.dailyFacts.subtitle"
  [panelled]="false"
>
  <div class="daily-facts-panel">
    @if (isLoading()) {
      <div class="loading-state">
        <mat-spinner diameter="40"></mat-spinner>
        <p>{{ 'app.admin.dailyFacts.loading' | translate }}</p>
      </div>
    } @else if (hasFacts()) {
      <app-daily-facts-table
        [facts]="facts()"
        [getVideoStatusLabel]="getVideoStatusLabel"
        [getVideoStatusClass]="getVideoStatusClass"
        [canReviewVideo]="canReviewVideo"
        [isGenerating]="isGenerating"
        (generateVideo)="generateVideo($event)"
        (reviewVideo)="reviewVideo($event)"
      />

      <div class="facts-cards facts-cards--mobile">
        @for (fact of facts(); track fact.id) {
          <app-daily-fact-card
            [fact]="fact"
            [getVideoStatusLabel]="getVideoStatusLabel"
            [getVideoStatusClass]="getVideoStatusClass"
            [canReviewVideo]="canReviewVideo"
            [isGenerating]="isGenerating"
            (generateVideo)="generateVideo($event)"
            (reviewVideo)="reviewVideo($event)"
          />
        }
      </div>

      @if (hasFacts() && totalCount() > pageSize()) {
        <app-daily-facts-pagination
          [page]="page()"
          [pageSize]="pageSize()"
          [totalCount]="totalCount()"
          [isLoading]="isLoading()"
          (pageChange)="goToPage($event)"
        />
      }
    } @else {
      <p class="empty-state">{{ 'app.admin.dailyFacts.empty' | translate }}</p>
    }
  </div>

  <app-modal
    [isOpen]="videoReviewFact() !== null"
    [config]="{
      title: 'app.admin.dailyFacts.reviewVideo',
      minWidth: 'min(90vw, 800px)',
      maxWidth: 'min(90vw, 800px)',
      minHeight: 'auto',
      padding: '1.25rem 1.5rem 1.5rem'
    }"
    (closed)="closeVideoReview()"
  >
    @if (videoReviewFact(); as fact) {
      <div class="video-review-content">
        <p class="video-review-fact">{{ fact.fact }}</p>
        <p class="video-review-date">{{ fact.date }}</p>
        <video
          #videoEl
          class="video-review-player"
          [src]="fact.videoUrl"
          controls
          playsinline
          (loadedmetadata)="setPlaybackRate(videoEl, fact.videoPlaybackRate)"
        ></video>
      </div>
    }
  </app-modal>
</app-admin-page-shell>
